<template>
<ul>
    <li v-for="(node, index) in treeData" :key="index">
    <div @click="toggleNodeXML(node)" @dblclick="shareInfo(node)">
        <span v-if="node.children && node.children.length">
            <span v-if="node.expanded"> 
                <span class="material-symbols-outlined">folder_open</span>
            </span>
            <span v-else> 
                <span class="material-icons">folder</span>
            </span>
        </span>
        <span v-else>
            <span class="material-symbols-outlined">description</span>
        </span>
        {{ node.name }}
    </div>
    <ul v-if="node.expanded">
        <xml-tree 
        v-for="(child, idx) in node.children" 
            :key="idx" 
            :treeData="[child]"
            @shareNode = "shareInfo" 
        />
    </ul>
    </li>
</ul>
</template>

<script>
export default {
name: "xmlTree",
props: {
    treeData: Array // Die hierarchischen XML-Daten werden als Array von Objekten erwartet.
  },
data() {
    return {
      clickTimeout: null, // Timer für den Doppelklick
    };
  },
methods: {
    toggleNodeXML(node) {
    if (this.clickTimeout) {
        clearTimeout(this.clickTimeout);  // Lösche den Timer, falls es ein Doppelklick ist
        this.clickTimeout = null;
        return;
      }
    this.clickTimeout = setTimeout(() => {
        node.expanded = !node.expanded; // Schaltet den Zustand des Knotens um (geöffnet/geschlossen)
        this.clickTimeout = null;
    },180)},

    shareInfo(node) {
    clearTimeout(this.clickTimeout);  // Entferne den Einfachklick-Timer
    this.clickTimeout = null;  // Zurücksetzen des Timers
    this.$emit('shareNode', node)
    }
}};
</script>

<style scoped>
ul {
list-style-type: none;
padding-left: 20px;
}

li div {
cursor: pointer;
display: flex;
align-items: center;
}

.material-icons {
margin-right: 8px;
}
</style>
